import * as superagent from 'superagent';

import { superagentRequestToAPIPromise } from '../utils/superagent';

import { Deal } from './offer';

export interface ISubscribeForUpdatesData {
  email: string;
  dealType: Deal;
  query: string;
  source?: string;
}

export function subscribeForUpdates(email: string, dealType: Deal, query: string, source?: string): Promise<void> {
  return superagentRequestToAPIPromise(
    superagent
      .post('/ajax/subscriptions')
      .send({
        email,
        action: 'subscribe',
        deal_type: dealType,
        filter_params: query,
        source: source || '',
      })
      .set('Accept', 'application/json')
  );
}

export function subscribeForPriceChange(offerId: number, email: string) {
  return superagentRequestToAPIPromise(
    superagent
      .post('/cian-api/site/v1/change-price-subscribe/')
      .send({
        offerId,
        email,
      })
      .set('Accept', 'application/json')
  );
}

export function unsubscribeFromPriceChange(offerId: number, uuid?: string) {
  return superagentRequestToAPIPromise(
    superagent
      .post('/cian-api/site/v1/change-price-unsubscribe/')
      .send({
        offerId,
        uuid,
      })
      .set('Accept', 'application/json')
  );
}

export function unsubscribeFromAllUpdates(email: string, guid: string) {
  return superagentRequestToAPIPromise(
    superagent
      .post('/cian-api/site/v1/email/total-unsubscribe/')
      .send({
        email,
        guid,
      })
      .set('Accept', 'application/json')
  );
}

export function subscribeForOfferRequest(filterParams: string, email: string, offerRequestTypeId: number) {
  return superagentRequestToAPIPromise(
    superagent
      .post('/ajax/create-subscription-for-offer-request')
      .send({
        action: 'offer_request_subscribe',
        filter_params: filterParams,
        email,
        offer_request_type_id: offerRequestTypeId,
      })
      .set('Accept', 'application/json')
  );
}



// WEBPACK FOOTER //
// ./src/api/subscribe.ts